import type { FaireProductEntity } from "../../entity_types/product";

export const p_7g37ht83p8: FaireProductEntity = {
  token: "p_7g37ht83p8",
  type: "product",
  name: "Kit Kat 4 Finger Cookie Dough (41.5) (UK) 24ct",
  brandToken: "b_5fqs9qr72c",
  brandName: "Pops Distro Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/66820e65a3fd776d7e915c2af59f42df65db617096255d331331b16acb73bddc.png",
  galleryImageUrls: [],
  priceDollars: 91,
  description:
    "Classic crunch meets indulgent cookie dough 🍪🍫\nKitKat 4 Finger Cookie Dough layers crispy wafer fingers with smooth milk chocolate and a rich cookie dough–flavored filling. Imported from the UK, this 24-count case combines a familiar format with a highly in-demand flavor, making it a strong performer for wholesale and high-traffic retail.\n\n✨ Why Retailers Love It \n\n * \n🍪 Cookie Dough Filling – creamy, indulgent, and crowd-pleasing\n\n * \n🍫 Classic 4 Finger Format – instantly recognizable KitKat crunch\n\n * \n🇬🇧 Imported from the UK – international variety not widely sold in the U.S.\n\n * \n📦 24-Count Case – ideal for shelves, peg hooks, vending, and breakrooms\n\n * \n💰 High Sell-Through Potential – trusted brand + trending flavor\n\n📦 Case Details \n\n * \nBrand: KitKat\n\n * \nProduct Line: 4 Finger\n\n * \nFlavor: Cookie Dough\n\n * \nNet Weight: 41.5g per bar\n\n * \nPack Size: 24 bars per case\n\n * \nOrigin: United Kingdom\n\n * \nCategory: Imported chocolate / confectionery\n\n🏪 Ideal For \n\n * \nConvenience & gas\n\n * \nSpecialty candy & snack shops\n\n * \nInternational food aisles\n\n * \nVending, micro-markets, and office programs\n",
  tags: [],
  msrpDollars: 182,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:50.684Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
